var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVitejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 257,
    viewBox: "0 0 256 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.153 37.9382L134.897 252.977C132.414 257.417 126.035 257.443 123.515 253.025L0.874432 37.9589C-1.87112 33.1442 2.24595 27.3123 7.70191 28.2875L128.087 49.8056C128.855 49.9429 129.641 49.9416 130.409 49.8016L248.276 28.3184C253.714 27.3273 257.85 33.114 255.153 37.9382Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.433 0.0631039L96.4403 17.5009C94.9776 17.7875 93.8946 19.0271 93.8064 20.5147L88.3321 112.971C88.2033 115.149 90.2032 116.839 92.3287 116.349L117.106 110.631C119.424 110.096 121.519 112.138 121.042 114.469L113.681 150.516C113.185 152.942 115.463 155.016 117.832 154.297L133.136 149.647C135.508 148.927 137.788 151.007 137.286 153.435L125.588 210.056C124.856 213.598 129.567 215.529 131.531 212.493L132.844 210.465L205.36 65.7456C206.574 63.3225 204.48 60.5595 201.819 61.0731L176.315 65.9952C173.919 66.4573 171.88 64.2254 172.556 61.8805L189.202 4.1757C189.879 1.82693 187.833 -0.406958 185.433 0.0631039Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -2.11993,
    y1: 45.6368,
    x2: 127.576,
    y2: 221.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD34FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 139.244,
    y1: 4.79744,
    x2: 165.925,
    y2: 187.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0833333,
    stopColor: "#FFDD35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitejs);
export default __webpack_public_path__ + "static/media/vitejs.b99f0b09b9a423d657acad968d0e89b3.svg";
export { ForwardRef as ReactComponent };